import Parse from "parse";

import type { Item } from "./Item";

type OD3_Source = Parse.Object;
type OD3_Tenant = Parse.Object;

export interface SourceMetaAttributes {
  id: string;
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  item?: Item;
  source: OD3_Source;
  tenant: OD3_Tenant;
}

export class SourceMeta extends Parse.Object<SourceMetaAttributes> {
  static className: string = "OD3_Maintenance_SourceMeta";

  constructor(data?: Partial<SourceMetaAttributes>) {
    super("OD3_Maintenance_SourceMeta", data as SourceMetaAttributes);
  }

  get item(): Item | undefined {
    return super.get("item");
  }
  set item(value: Item | undefined) {
    super.set("item", value);
  }
  get source(): OD3_Source {
    return super.get("source");
  }
  set source(value: OD3_Source) {
    super.set("source", value);
  }
  get tenant(): OD3_Tenant {
    return super.get("tenant");
  }
  set tenant(value: OD3_Tenant) {
    super.set("tenant", value);
  }
}

Parse.Object.registerSubclass("OD3_Maintenance_SourceMeta", SourceMeta);
